.container {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
}

.spaceCheckbox {
  margin-left: 8px;
  margin-top: 4px;
  align-self: flex-end;
}

.results {
  overflow: auto;
}
